import * as ActionTypes from '../ActionTypes';


export const GetCtcCategoryAction = (params) => {
    return {
        type: ActionTypes.CTCCATEGORY_GET_REQUEST,
        params
    }
}

export const AddCtcCategoryAction = (params) => {
    return {
        type: ActionTypes.CTCCATEGORY_ADD_REQUEST,
        params
    }
}


export const UpdateCtcCategoryAction = (params) => {
    return {
        type: ActionTypes.CTCCATEGORY_UPDATE_REQUEST,
        params
    }
}


export const DeleteCtcCategoryAction = (params) => {
    return {
        type: ActionTypes.CTCCATEGORY_DELETE_REQUEST,
        params
    }
}

